import { AmericanState } from "shared/model/AmericanStates";
import { ApplicationStatus, IApplication } from "shared/model/IApplication";

import DateUtils from "./DateUtils";
import Utils from "./Utils";

interface DisplayString {
  text: string;
  className?: string;
}

export default class ApplicationUtils {
  public static applicationStatus(
    status: ApplicationStatus,
    defaultClassName: string,
    positiveClassName: string,
    negativeClassName: string,
    notImportnatnClassName: string,
    partiallyPositiveClassName: string
  ): DisplayString {
    let className = `${defaultClassName} `;

    switch (status) {
      case ApplicationStatus.Canceled:
        className += notImportnatnClassName;
        break;
      case ApplicationStatus.Concluded:
        className += partiallyPositiveClassName;
        break;
      case ApplicationStatus.Approved:
        className += positiveClassName;
        break;
      case ApplicationStatus.Funded:
        className += positiveClassName;
        break;
      case ApplicationStatus.Declined:
        className += negativeClassName;
        break;
      default:
        break;
    }

    const name = ApplicationUtils.applicationStatusName(status);

    return {
      text: name,
      className
    };
  }

  public static applicationStatusName(status: ApplicationStatus) {
    switch (status) {
      case undefined:
        return "N/A";
      case ApplicationStatus.UnderReview:
        return "Under Review";
      case ApplicationStatus.InCollection:
        return "In Collection";
      default:
        return Utils.capitalizeFirstLetter(status);
    }
  }

  public static dateFromFirebaseTimestamp(createdAt: any) {
    if (createdAt && createdAt.seconds) {
      return new Date(createdAt.seconds * 1000);
    } else if (createdAt instanceof Date) {
      return createdAt;
    } else if (createdAt) {
      return new Date();
    } else {
      return undefined;
    }
  }

  public static dateText(createdAt: any, defaultText: string = "N/A") {
    const date = ApplicationUtils.dateFromFirebaseTimestamp(createdAt);
    if (date) {
      return DateUtils.format(date);
    } else {
      return defaultText;
    }
  }

  public static longDateText(createdAt: any, defaultText: string = "N/A") {
    const date = ApplicationUtils.dateFromFirebaseTimestamp(createdAt);
    if (date) {
      return DateUtils.longFormat(date);
    } else {
      return defaultText;
    }
  }

  public static amountText = (
    application: IApplication,
    specialCurrencyClass: string
  ): DisplayString => {
    const { amount, branchState } = application;
    let text;
    let className;
    if (!amount) {
      text = "N/A";
    } else if (branchState === AmericanState.ISR) {
      text = `₪${amount}`;
      className = specialCurrencyClass;
    } else {
      text = `$${amount}`;
    }

    return {
      text,
      className
    };
  };

  public static applicationName(application: IApplication) {
    const { contract, applicant, applicantEmail } = application;
    if (applicant && applicant.name) {
      return applicant.name;
    } else if (applicantEmail) {
      return applicantEmail;
    } else if (contract && contract.originalFileName) {
      return contract.originalFileName;
    } else {
      return "N/A";
    }
  }

  public static applicantFirstName(application: IApplication) {
    if (application && application.applicant) {
      const name = application.applicant.name || " ";
      return name.split(" ")[0];
    } else {
      return "";
    }
  }

  public static applicantNameParts(application: IApplication) {
    if (application && application.applicant) {
      const { name } = application.applicant;

      if (name) {
        const parts = name.split(" ");

        return {
          first: parts[0],
          full: name
        };
      }
    }

    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/ApplicationUtils.ts